"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
var logger_1 = require("../log/logger");
function arrayOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = []; }
    logger_1.Log.info('Root ', root, ' path ', path);
    logger_1.Log.info(decorators);
    var array = [].concat(getter_1.getDefinedOrElse(root, path, orElse)).map(function (el) { return decorator_1.decorate(el, decorators); });
    return array.concat(orElse.slice(array.length));
}
exports.arrayOr = arrayOr;
//# sourceMappingURL=arrayOr.js.map